'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rcSlider = require('rc-slider');

var _rcSlider2 = _interopRequireDefault(_rcSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Slider = function (_React$Component) {
    (0, _inherits3["default"])(Slider, _React$Component);

    function Slider() {
        (0, _classCallCheck3["default"])(this, Slider);
        return (0, _possibleConstructorReturn3["default"])(this, _React$Component.apply(this, arguments));
    }

    Slider.prototype.render = function render() {
        return _react2["default"].createElement(_rcSlider2["default"], this.props);
    };

    return Slider;
}(_react2["default"].Component);

exports["default"] = Slider;

Slider.defaultProps = {
    prefixCls: 'ant-slider',
    tooltipPrefixCls: 'ant-tooltip',
    tipTransitionName: 'zoom-down'
};
Slider.propTypes = {
    prefixCls: _react.PropTypes.string,
    tipTransitionName: _react.PropTypes.string
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/slider/index.tsx
 ** module id = 349
 ** module chunks = 0
 **/